import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, TranslocoModule, CommonModule ],
  template: `<router-outlet></router-outlet>`
})
export class AppComponent {
  title = 'ansiao-website';
  private translocoService = inject(TranslocoService);

  toggleLang() {
    const newLang = this.translocoService.getActiveLang() === 'pt' ? 'en' : 'pt';
    this.translocoService.setActiveLang(newLang);
  }

  changelanguage(idioma: string) {
    this.translocoService.setActiveLang(idioma);
    localStorage.setItem('userLang', idioma); // Guarda la elección
  }

  ngOnInit() {
    const savedLang = localStorage.getItem('userLang');
    if (savedLang) {
      this.translocoService.setActiveLang(savedLang);
    }
  }

}